/**
 * Bundle Builder UI with Configurable Per-Session Bonus Tiers
 * - Supports any number of tiers (e.g., 10% get +3, 10% get +2, 40% get +1, 40% get +0)
 * - Configuration is via the BONUS_TIERS array below
 * - Only one bonus is applied per session, and sessionStorage is used for persistence
 */

(function () {
  // --- Configurable Bonus Tiers ---
  // Format: [{ chance: 0.1, bonus: 3 }, { chance: 0.1, bonus: 2 }, { chance: 0.4, bonus: 1 }, { chance: 0.4, bonus: 0 }]
  // The sum of all 'chance' values should equal 1.0 (100%)
  const BONUS_TIERS = [
    { chance: 0.01, bonus: 3 }, //  1% get +3
    { chance: 0.05, bonus: 2 }, //  5% get +2
    { chance: 0.35, bonus: 1 }, // 35% get +1
    { chance: 0.59, bonus: 0 }, // 59% get +0 (no bonus)
  ];

  // Session key names (configurable for namespacing if needed)
  const SESSION_DECIDED_KEY = 'bundle_bonus_session_decided';
  const SESSION_BONUS_AMOUNT_KEY = 'bundle_bonus_amount';

  // --- Per-session bonus logic ---
  function getSessionBonusAmount() {
    if (sessionStorage.getItem(SESSION_DECIDED_KEY) === 'true') {
      return parseInt(sessionStorage.getItem(SESSION_BONUS_AMOUNT_KEY), 10) || 0;
    }
    // Pick a tier based on their respective chances (first match wins)
    const r = Math.random();
    let cumulative = 0;
    let bonusAmount = 0;
    for (let i = 0; i < BONUS_TIERS.length; i++) {
      cumulative += BONUS_TIERS[i].chance;
      if (r < cumulative) {
        bonusAmount = BONUS_TIERS[i].bonus;
        break;
      }
    }
    sessionStorage.setItem(SESSION_DECIDED_KEY, 'true');
    sessionStorage.setItem(SESSION_BONUS_AMOUNT_KEY, String(bonusAmount));
    return bonusAmount;
  }

  function sessionHasBonus() {
    return getSessionBonusAmount() > 0;
  }

  function getActiveLimit(bundleIndex, limitsArray) {
    const base = limitsArray[bundleIndex];
    return base + getSessionBonusAmount();
  }

  function findSmallestFittingBundleIndex(count, limitsArray) {
    for (let i = 0; i < limitsArray.length; i++) {
      if (getActiveLimit(i, limitsArray) >= count) return i;
    }
    return limitsArray.length - 1;
  }

  function maybeShowBonusPopupOnce(sectionId) {
    if (!window.__bonus_popup_shown && sessionHasBonus()) {
      window.__bonus_popup_shown = true;
      showBonusBundlePopup();
    }
  }

  function showBonusBundlePopup() {
    const bonus = getSessionBonusAmount();
    let popup = document.getElementById('bundle-bonus-popup');
    let bonusLine = "";
    if (bonus > 1) {
      bonusLine = `You can squeeze <b>${bonus} more</b> FlexiPals in every bundle—on us!`;
    } else if (bonus === 1) {
      bonusLine = "You can squeeze <b>one more</b> FlexiPal in every bundle—on us!";
    }
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'bundle-bonus-popup';
      popup.style = "position: fixed; z-index: 99999; left: 0; top: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center;";
      popup.innerHTML =
        `<div style="background: #fff; border-radius: 12px; max-width: 95vw; width: 350px; box-shadow: 0 12px 36px rgba(0,0,0,0.13); padding: 32px 24px 24px 24px; text-align: center; font-family: inherit;">
          <h2 style="font-size: 1.25rem; margin-bottom: 0.5em; color: #6CB4EE;">🎉 Lucky You!</h2>
          <p style="margin-bottom: 2em; color: #000000">${bonusLine}</p>
          <button id="bundle-bonus-close" style="background: #6CB4EE; color: #fff; border: none; border-radius: 4px; font-size: 1rem; padding: 10px 32px; cursor: pointer; font-weight: 600;">Awesome!</button>
        </div>`;
      document.body.appendChild(popup);
      document.getElementById('bundle-bonus-close').onclick = () => { popup.style.display = 'none'; };
    } else {
      popup.querySelector('p').innerHTML = bonusLine;
    }
    popup.style.display = 'flex';
  }

  // --- SVG/Canvas Pop Animation ---
  function triggerBagBonusAnimation() {
    const fillRect = document.getElementById('bagFillRect');
    if (fillRect) {
      fillRect.classList.remove('bag-stuffed');
      void fillRect.offsetWidth; // Force reflow
      fillRect.classList.add('bag-stuffed');
    }
    const bagInner = document.querySelector('#bundleToggleBtn .bag-pop-inner');
    if (bagInner) {
      bagInner.classList.remove('bag-pop');
      void bagInner.offsetWidth;
      bagInner.classList.add('bag-pop');
      setTimeout(() => bagInner.classList.remove('bag-pop'), 700);
    }
  }

  // --- Utility: Parse config from DOM ---
  function getBundleConfig() {
    const sectionId = document.getElementById('bundle-section-id')?.value;
    let limitsArray = document.getElementById('bundle-limits-array')?.value;
    let bundlePrices = document.getElementById('bundle-variants-array')?.value;
    const product_form_id = document.getElementById('bundle-product-form-id')?.value;
    try {
      limitsArray = limitsArray ? JSON.parse(limitsArray) : [];
      bundlePrices = bundlePrices ? JSON.parse(bundlePrices) : [];
    } catch (e) {
      limitsArray = [];
      bundlePrices = [];
    }
    return { sectionId, limitsArray, bundlePrices, product_form_id };
  }

  function formatMoneyForBuyItWith(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (typeof window !== 'undefined' && window.money_format) || '{{ amount }}';
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number === null) return '0';
      number = (number / 100.0).toFixed(precision);
      const [dollars, cents] = number.split('.');
      const formattedDollars = dollars.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return formattedDollars + (cents ? decimal + cents : '');
    }
    const match = formatString.match(placeholderRegex);
    const formatType = match ? match[1] : 'amount';
    let value;
    switch (formatType) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = cents;
    }
    return formatString.replace(placeholderRegex, value);
  }

  function setColorPreference(value, el) {
    document.getElementById('color-preference-input').value = value;
    document.querySelectorAll('.color-button').forEach(btn => btn.classList.remove('color-active'));
    el.classList.add('color-active');
  }
  window.setColorPreference = setColorPreference;

  function moveSidebarProductsWrapper(sectionId) {
    const sidebarWrapper = document.getElementById('bundleSidebarProductsWrapper-' + sectionId);
    if (!sidebarWrapper) return;
    const desktopTarget = document.getElementById('sidebarProductsDesktopTarget');
    const mobileTarget = document.getElementById('sidebarProductsMobileTarget');
    const isMobile = window.innerWidth < 1023;
    const section = document.getElementById('bundleSection');
    if (isMobile) {
      if (mobileTarget && sidebarWrapper.parentNode !== mobileTarget) mobileTarget.appendChild(sidebarWrapper);
      if (mobileTarget) mobileTarget.style.display = (section && section.classList.contains('bundle-expanded')) ? 'block' : 'none';
      if (desktopTarget) desktopTarget.style.display = 'none';
    } else {
      if (desktopTarget && sidebarWrapper.parentNode !== desktopTarget) desktopTarget.appendChild(sidebarWrapper);
      if (desktopTarget) desktopTarget.style.display = 'block';
      if (mobileTarget) mobileTarget.style.display = 'none';
    }
  }

  function updateBagFill() {
    const btn = document.getElementById('bundleToggleBtn');
    const fillRect = btn?.querySelector('#bagFillRect');
    if (!fillRect || window.innerWidth >= 1023) return;
    try {
      const minY = 16, maxY = 32, height = 16;
      let count = 0, max = 1;
      if (window.__bundle_totalAddedCount) {
        count = window.__bundle_totalAddedCount();
        max = window.__bundle_currentLimit ? window.__bundle_currentLimit() : 1;
      }
      if (!count) {
        const el = document.querySelector('[class^="bundle-status-"]');
        if (el) {
          const m = el.innerText.match(/^(\d+)\s*\/\s*(\d+)/);
          if (m) {count = +m[1]; max = +m[2];}
        }
      }
      const percent = Math.max(0, Math.min(1, count / max));
      const fillH = Math.round(height * percent);
      fillRect.setAttribute('y', maxY - fillH);
      fillRect.setAttribute('height', fillH);
      // "Stuffed" bag indicator only applies if bonus awarded for the session
      if (
        count === max &&
        max > 0 &&
        sessionHasBonus()
      ) {
        fillRect.classList.add('bag-stuffed');
        triggerBagBonusAnimation();
      } else {
        fillRect.classList.remove('bag-stuffed');
      }
    } catch (e) {}
  }

  function initBundle3() {
    const config = getBundleConfig();
    if (!config.sectionId || !config.limitsArray.length) return;
    const sectionId = config.sectionId;
    moveSidebarProductsWrapper(sectionId);
    window.addEventListener('resize', () => moveSidebarProductsWrapper(sectionId));

    const limitsArray = config.limitsArray.slice();
    const bundleVariantEls = document.querySelectorAll('.bundle-variant-' + sectionId);
    const mainButton = document.querySelector('.bundle-button-' + sectionId);
    const products = document.querySelectorAll('.bundle-product-' + sectionId);
    const emptyProduct = document.querySelector('.bundle-sidebar-product-empty-' + sectionId);
    const bundleInputProperty = document.querySelector('.bundle-input-property-' + sectionId);
    const status = document.querySelector('.bundle-status-' + sectionId);
    const fixed = document.querySelector('.bundle-fixed-' + sectionId);
    const section = document.querySelector('.bundle-' + sectionId);

    let bundleSelectIndex = 0;
    let manualBundleIndex = 0;
    let selectedProducts = {};

    window.__bundle_totalAddedCount = () => Object.values(selectedProducts).reduce((a, b) => a + b, 0);
    window.__bundle_currentLimit = () => getActiveLimit(bundleSelectIndex, limitsArray);

    function adjustProductQty(dataId, newQty) {
      if (!newQty || newQty < 1) {
        delete selectedProducts[dataId];
      } else {
        selectedProducts[dataId] = newQty;
      }
      const count = window.__bundle_totalAddedCount();
      let nextIndex = findSmallestFittingBundleIndex(count, limitsArray);
      if (nextIndex < manualBundleIndex) nextIndex = manualBundleIndex;
      selectBundleVariant(nextIndex, false);
      maybeShowBonusPopupOnce(sectionId);
      updateBagFill();
      if (fixed && section && window.innerWidth < 1023 && count > 0) fixed.style.display = 'block';
    }

    function renderSidebarProducts() {
      const container = document.querySelector('.bundle-sidebar-products-' + sectionId);
      if (!container) return;
      const scrollContainer = document.querySelector('.bundle-bag-section');
      const scrollTop = scrollContainer ? scrollContainer.scrollTop : 0;
      const toRemove = container.querySelectorAll('.bundle-sidebar-product-' + sectionId + ':not(.bundle-sidebar-product-default-' + sectionId + ')');
      Array.prototype.forEach.call(toRemove, el => el.remove());
      for (const dataId in selectedProducts) {
        if (!selectedProducts.hasOwnProperty(dataId)) continue;
        const prod = Array.prototype.find.call(products, p => p.getAttribute('data-id') === dataId);
        let imageSrc = '', imageAlt = '', productTitle = '';
        if (prod) {
          const image = prod.querySelector('.bundle-product-image-' + sectionId + ' img');
          imageSrc = image ? image.src : '';
          imageAlt = image ? image.alt : '';
          productTitle = prod.querySelector('.bundle-product-title-' + sectionId).innerText;
        } else if (dataId === "10184328216881") {
          imageSrc = 'https://cdn.shopify.com/s/files/1/0922/9556/1521/files/question_mark.webp?v=1739893477';
          imageAlt = 'Mystery FlexiPal';
          productTitle = 'Mystery FlexiPal';
        } else continue;
        const countVal = selectedProducts[dataId];
        const newDiv = document.createElement('div');
        newDiv.className = 'bundle-sidebar-product-' + sectionId;
        newDiv.setAttribute('data-id', dataId);
        const leftDiv = document.createElement('div');
        leftDiv.className = 'bundle-sidebar-product-left-' + sectionId;
        const imageDiv = document.createElement('div');
        imageDiv.className = 'bundle-sidebar-product-image-' + sectionId;
        if (imageSrc) {
          const imageElement = document.createElement('img');
          imageElement.src = imageSrc;
          imageElement.alt = imageAlt;
          imageDiv.appendChild(imageElement);
        }
        const titleSpan = document.createElement('p');
        titleSpan.className = 'bundle-sidebar-product-title-' + sectionId;
        titleSpan.innerText = productTitle;
        leftDiv.appendChild(imageDiv);
        leftDiv.appendChild(titleSpan);
        const rightDiv = document.createElement('div');
        rightDiv.className = 'bundle-sidebar-product-right-' + sectionId;
        const qtyBorderWrap = document.createElement('div');
        qtyBorderWrap.className = 'bundle-sidebar-product-qty-border-' + sectionId;
        Object.assign(qtyBorderWrap.style, {
          display: 'flex', alignItems: 'center', gap: '8px',
          border: '1px solid #D8D8D8', borderRadius: '6px',
          padding: '2px 8px', background: '#fff', color: '#000000', width: 'fit-content'
        });
        const minusBtn = document.createElement('span');
        minusBtn.setAttribute('btnfor', 'minus');
        minusBtn.className = "ITGQtyAdjust btnqty qtyminus icon icon-minus";
        minusBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12.3957H19" stroke="#000000" stroke-linecap="round" stroke-width="2"/></svg>';
        minusBtn.style.cursor = 'pointer';
        minusBtn.addEventListener('click', function (e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          adjustProductQty(dataId, (selectedProducts[dataId] || 1) - 1);
        });
        const qtyInput = document.createElement('input');
        qtyInput.setAttribute('data-id', dataId);
        qtyInput.type = "text";
        qtyInput.value = countVal;
        qtyInput.className = "quantity-selector quantity-input";
        qtyInput.setAttribute('readonly', '');
        Object.assign(qtyInput.style, {
          width: '2.6ch', textAlign: 'center', border: 'none',
          background: 'transparent', fontWeight: 'bold',
          fontSize: '16px', padding: '0', margin: '0'
        });
        const plusBtn = document.createElement('span');
        plusBtn.setAttribute('btnfor', 'plus');
        plusBtn.className = "ITGQtyAdjust btnqty qtyplus icon icon-plus";
        plusBtn.innerHTML = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.39569V19.3957" stroke="#000000" stroke-linecap="round" stroke-width="2"/><path d="M5 12.3957H19" stroke="#000000" stroke-linecap="round" stroke-width="2"/></svg>';
        plusBtn.style.cursor = 'pointer';
        plusBtn.addEventListener('click', function (e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          addProduct(dataId);
        });
        qtyBorderWrap.appendChild(minusBtn);
        qtyBorderWrap.appendChild(qtyInput);
        qtyBorderWrap.appendChild(plusBtn);
        rightDiv.appendChild(qtyBorderWrap);
        newDiv.appendChild(leftDiv);
        newDiv.appendChild(rightDiv);
        container.appendChild(newDiv);
      }
      if (emptyProduct) emptyProduct.classList.toggle('active', window.__bundle_totalAddedCount() > 0);
      updateBundleInputProperty();
      if (scrollContainer) scrollContainer.scrollTop = scrollTop;
    }

    function refreshProductCards() {
      products.forEach(el => {
        const dataId = el.getAttribute('data-id');
        const btn = el.querySelector('.bundle-product-button-' + sectionId);
        const quantity = el.querySelector('.bundle-product-quantity-' + sectionId);
        const plusBtn = el.querySelector('.ITGQtyAdjust.qtyplus');
        if (selectedProducts[dataId]) {
          el.classList.add('active');
          if (quantity) quantity.innerText = selectedProducts[dataId];
          if (btn) btn.setAttribute('disabled', true);
        } else {
          el.classList.remove('active');
          if (quantity) quantity.innerText = '1';
          if (btn) btn.removeAttribute('disabled');
        }
        if (plusBtn) {
          const totalCount = window.__bundle_totalAddedCount();
          const atLimit = totalCount >= window.__bundle_currentLimit();
          const atLargestBundle = bundleSelectIndex === limitsArray.length - 1;
          if (atLargestBundle && atLimit) {
            plusBtn.setAttribute('disabled', true);
          } else {
            plusBtn.removeAttribute('disabled');
          }
        }
      });
      const atLargestBundle = bundleSelectIndex === limitsArray.length - 1;
      const atAbsoluteLimit = window.__bundle_totalAddedCount() >= window.__bundle_currentLimit();
      products.forEach(el => {
  const btn = el.querySelector('.bundle-product-button-' + sectionId);
  if (btn) {
    // Check if button text contains "SOLD OUT"
    const isSoldOut = btn.innerText.includes('SOLD OUT');
    
    if (atLargestBundle && atAbsoluteLimit) {
      btn.setAttribute('disabled', true);
    } else if (! isSoldOut) {
      // Only remove disabled if NOT sold out
      btn.removeAttribute('disabled');
    } else {
      // Keep disabled if sold out
      btn.setAttribute('disabled', true);
    }
  }
});
      if (mainButton) {
        const currentCount = window.__bundle_totalAddedCount();
        if (currentCount === window.__bundle_currentLimit()) mainButton.removeAttribute('disabled');
        else mainButton.setAttribute('disabled', true);
      }
      updateStatus();
      updateMainButtonText();
      updateMysteryButtonState();
    }

    function updateBundleInputProperty() {
  if (!bundleInputProperty) return;
  const sidebarProducts = document.querySelectorAll('.bundle-sidebar-product-' + sectionId);

  bundleInputProperty.value = Array.from(sidebarProducts).map(product => {
    const titleEl = product.querySelector('.bundle-sidebar-product-title-' + sectionId);
    const title = titleEl ? titleEl.innerText.trim() : '';

    // Prefer the original product card's data-bin-id (the element you showed has it).
    // Sidebar items have data-id set when they are created (newDiv.setAttribute('data-id', dataId)).
    const dataId = product.getAttribute('data-id');
    let bin = 'N/A';

    if (dataId) {
      // Try to find the original product card for this data-id.
      const prodCard =
        document.querySelector('.bundle-product-' + sectionId + '[data-id="' + dataId + '"]') ||
        document.querySelector('[data-id="' + dataId + '"]');

      if (prodCard) {
        bin = prodCard.getAttribute('data-bin-id') || prodCard.getAttribute('data-bin') || 'N/A';
      }
    } else {
      // As a fallback, check if the sidebar title itself was given a data-bin-id.
      bin = titleEl ? (titleEl.getAttribute('data-bin-id') || 'N/A') : 'N/A';
    }

    const count = product.querySelector('.quantity-input').value;
    return `${title} ${bin} (x${count})`;
  }).join(' | ');
}

    function updateStatus() {
  if (!status) return;
  const count = window.__bundle_totalAddedCount(); // Total items selected
  const baseLimit = limitsArray[bundleSelectIndex]; // Regular item limit
  const hasBonus = sessionHasBonus();
  const bonusLimit = hasBonus ? getSessionBonusAmount() : 0; // Max bonus items allowed

  // Calculate bonusAmount as overflow past baseLimit, but capped at bonusLimit
  let bonusAmount = 0;
  if (hasBonus && count > baseLimit) {
    bonusAmount = Math.min(count - baseLimit, bonusLimit);
  }

  const selectedCount = count - bonusAmount; // Regular items selected

  let line = `${selectedCount}/${baseLimit} Selected`;
  if (hasBonus && bonusLimit > 0) {
    line += `\n+ ${bonusAmount}/${bonusLimit} BONUS`;
  }

  status.innerText = line;

  // --- Add or remove Bonus Amount input ---
  const form = status.closest('form') || document.querySelector('form');
  let bonusInput = form.querySelector('.bonus-amount-input');

  if (bonusAmount > 0) {
    if (!bonusInput) {
      bonusInput = document.createElement('input');
      bonusInput.type = 'hidden';
      bonusInput.name = 'properties[Bonus Amount]';
      bonusInput.className = 'bonus-amount-input';
      form.appendChild(bonusInput);
    }
    bonusInput.value = bonusAmount;
  } else {
    if (bonusInput) {
      bonusInput.parentNode.removeChild(bonusInput);
    }
  }
}

    function updateAllBundleUI() {
      renderSidebarProducts();
      refreshProductCards();
      updateMainButtonText();
      updateStatus();
      updateMysteryButtonState();
      updateBagFill();
    }
    function updateMainButtonText() {
  if (!mainButton) return;
  const addMoreCount = window.__bundle_currentLimit() - window.__bundle_totalAddedCount();
  const activeVariantEl = document.querySelector('.bundle-variant-' + sectionId + '.active');
  let priceString = '';
  if (activeVariantEl) {
    const priceEl = activeVariantEl.querySelector('.bundle-variant-price-' + sectionId);
    if (priceEl) {
      // Get only the direct text node (before the per-unit-cost span)
      for (let node of priceEl.childNodes) {
        if (node.nodeType === Node.TEXT_NODE) {
          priceString = node. textContent.trim();
          break;
        }
      }
      // Fallback if no text node found
      if (! priceString) {
        priceString = priceEl.textContent.trim();
      }
    }
  }
  mainButton.innerHTML = (window.__bundle_totalAddedCount() < window.__bundle_currentLimit())
    ? `Add <span class="add-more-count">${addMoreCount}</span> More FlexiPals`
    : `Add to Cart - <span class="bundle-price">${priceString}</span>`;
}
    function selectBundleVariant(index, updateManual) {
      bundleSelectIndex = index;
      if (updateManual) manualBundleIndex = index;
      bundleVariantEls.forEach((el, i) => el.classList.toggle('active', i === index));
      const variantId = bundleVariantEls[index].getAttribute('data-variant-id');
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantId) variantInput.value = variantId;
      updateAllBundleUI();
    }

    function addProduct(dataId) {
      const totalCount = window.__bundle_totalAddedCount();
      const currentLimit = window.__bundle_currentLimit();
      const atLimit = totalCount >= currentLimit;
      const atLargestBundle = bundleSelectIndex === limitsArray.length - 1;
      if (atLimit && !atLargestBundle) {
        const nextIndex = bundleSelectIndex + 1;
        selectBundleVariant(nextIndex, false);
        setTimeout(() => {
          if (window.__bundle_totalAddedCount() < window.__bundle_currentLimit()) {
            adjustProductQty(dataId, (selectedProducts[dataId] || 0) + 1);
          }
        }, 0);
        return;
      }
      if (window.__bundle_totalAddedCount() < window.__bundle_currentLimit()) {
        adjustProductQty(dataId, (selectedProducts[dataId] || 0) + 1);
      }
    }

    function removeProduct(dataId) {
      if (!selectedProducts[dataId]) return;
      adjustProductQty(dataId, (selectedProducts[dataId] || 1) - 1);
    }
    function mysteryFill() {
      const mysteryId = "10184328216881";
      const spotsToFill = window.__bundle_currentLimit() - window.__bundle_totalAddedCount();
      if (spotsToFill <= 0) return;
      adjustProductQty(mysteryId, (selectedProducts[mysteryId] || 0) + spotsToFill);
    }
    function createMysteryFillButton() {
      const container = document.getElementById('mystery-fill-btn-container');
      if (!container || container.querySelector('.mystery-fill-button-' + sectionId)) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'mystery-fill-button-wrapper';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mystery-fill-button-' + sectionId;
      btn.innerText = 'Surprise Me!';
      btn.addEventListener('click', mysteryFill);
      wrapper.appendChild(btn);
      container.appendChild(wrapper);
      updateMysteryButtonState();
    }
    function updateMysteryButtonState() {
      const btn = document.querySelector('.mystery-fill-button-' + sectionId);
      if (!btn) return;
      btn.disabled = window.__bundle_totalAddedCount() >= window.__bundle_currentLimit();
    }
    products.forEach(el => {
      const btn = el.querySelector('.bundle-product-button-' + sectionId);
      if (btn) btn.addEventListener('click', () => addProduct(el.getAttribute('data-id')));
      const quantityWrap = el.querySelector('.bundle-product-quantity-wrapper-' + sectionId);
      if (quantityWrap) {
        const minus = quantityWrap.querySelector('.bundle-product-quantity-minus-' + sectionId);
        const plus = quantityWrap.querySelector('.bundle-product-quantity-plus-' + sectionId);
        if (minus) minus.addEventListener('click', () => removeProduct(el.getAttribute('data-id')));
        if (plus) plus.addEventListener('click', () => addProduct(el.getAttribute('data-id')));
      }
    });
    bundleVariantEls.forEach((el, i) => {
      el.addEventListener('click', function () {
        const count = window.__bundle_totalAddedCount();
        const allowed = getActiveLimit(i, limitsArray);
        if (i >= bundleSelectIndex) {
          selectBundleVariant(i, true);
          maybeShowBonusPopupOnce(sectionId);
        } else {
          if (count <= allowed) {
            selectBundleVariant(i, true);
            maybeShowBonusPopupOnce(sectionId);
          } else {
            showDowngradeBlockedPopup(allowed, count);
          }
        }
      });
    });
    const searchInput = document.querySelector('.bundle-search-input-' + sectionId);
    const filterSelect = document.querySelector('.bundle-filter-select-' + sectionId);
    function filterProducts() {
      const searchTerm = (searchInput && searchInput.value) ? searchInput.value.toLowerCase() : '';
      const filterTag = (filterSelect && filterSelect.value) ? filterSelect.value.toLowerCase() : '';
      products.forEach(card => {
        const title = (card.getAttribute('data-title') || '').toLowerCase();
        const tags = (card.getAttribute('data-tags') || '').toLowerCase().split('-');
        const isExcluded = title.trim() === 'mystery flexipal';
        const matchesSearch = !searchTerm || title.indexOf(searchTerm) !== -1;
        const matchesFilter = !filterTag || tags.some(tag => tag.indexOf(filterTag) !== -1);
        if (!isExcluded && matchesSearch && matchesFilter) {
          card.classList.remove('filtered-out');
        } else {
          card.classList.add('filtered-out');
        }
      });
    }
    if (searchInput) searchInput.addEventListener('input', filterProducts);
    if (filterSelect) filterSelect.addEventListener('change', filterProducts);
    if (fixed && section && window.innerWidth < 1023) fixed.style.display = 'none';
    manualBundleIndex = 0;
    selectBundleVariant(0, true);
    updateAllBundleUI();
    createMysteryFillButton();
    updateMysteryButtonState();
    updateBagFill();
    maybeShowBonusPopupOnce(sectionId);

    // --- "More Info" overlay feature ---
    // Attach event delegation for "more info" links
    // More robust "More Info" overlay feature

function closeProductOverlayFromButton(e) {
  e.preventDefault();
  const closeBtn = e.currentTarget;
  // Close button is inside overlay, find the overlay ancestor and remove it.
  const overlay = closeBtn.closest('.bundle-product-overlay');
  if (overlay) overlay.remove();
}

function createAndAttachOverlay(productEl, descHtml) {
  // Remove any existing overlays inside this product
  productEl.querySelectorAll('.bundle-product-overlay').forEach(o => o.remove());

  // Ensure the product element provides a positioned container so absolute overlay stays inside
  const productStyle = window.getComputedStyle(productEl);
  if (productStyle.position === 'static' || !productStyle.position) {
    // Only change inline style if necessary
    productEl.style.position = 'relative';
  }

  // Create overlay
  const overlay = document.createElement('div');
  overlay.className = 'bundle-product-overlay';
  overlay.innerHTML = `
    <div class="bundle-product-overlay-inner" role="dialog" aria-modal="true">
      <button type="button" class="bundle-product-overlay-close" aria-label="Close">✕</button>
      <div class="bundle-product-overlay-content">${descHtml}</div>
    </div>
  `;

  // Clicking the overlay background (not the inner content) should close it
  overlay.addEventListener('click', function (ev) {
    if (ev.target === overlay) {
      overlay.remove();
    }
  });

  // Prevent clicks inside content from bubbling to overlay
  const inner = overlay.querySelector('.bundle-product-overlay-inner');
  if (inner) {
    inner.addEventListener('click', function (ev) {
      ev.stopPropagation();
    });
  }

  // Attach close button handlers
  const closeBtn = overlay.querySelector('.bundle-product-overlay-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeProductOverlayFromButton);
    closeBtn.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault();
        closeProductOverlayFromButton(ev);
      }
    });
  }

  // Append overlay to the product element so it stays inside that card
  productEl.appendChild(overlay);

  // Move focus to the close button for accessibility
  if (closeBtn) closeBtn.focus();

  return overlay;
}

function handleMoreInfoClick(e, sectionId) {
  e.preventDefault();
  e.stopPropagation();

  const btn = e.currentTarget;

  // Try a few fallbacks to find the product element:
  // 1) the specific class `.bundle-product-<sectionId>`
  // 2) `.bundle-product` generic class
  // 3) any ancestor that stores the description in data-description-html
  let productEl = btn.closest('.bundle-product-' + sectionId) ||
                  btn.closest('.bundle-product') ||
                  btn.closest('[data-description-html]');

  if (!productEl) return;

  const descHtml = productEl.getAttribute('data-description-html') || '';

  createAndAttachOverlay(productEl, descHtml);
}

// Initialization: attach listeners to all "more info" links
// `products` is assumed to be a NodeList/Array of product elements and `sectionId` available in outer scope
products.forEach(productEl => {
  const moreInfo = productEl.querySelector('.bundle-product-more-info-link');
  if (moreInfo) {
    // pass sectionId from outer scope into the handler so we can use it in closest lookup
    moreInfo.addEventListener('click', function (e) { handleMoreInfoClick(e, sectionId); });
  }
});
  }

  function showDowngradeBlockedPopup(targetLimit, currentCount) {
    let popup = document.getElementById('bundle-downgrade-blocked-popup');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'bundle-downgrade-blocked-popup';
      popup.style = "position: fixed; z-index: 99999; left: 0; top: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center;";
      popup.innerHTML =
        `<div style="background: #fff; border-radius: 12px; max-width: 95vw; width: 350px; box-shadow: 0 12px 36px rgba(0,0,0,0.13); padding: 32px 24px 24px 24px; text-align: center; font-family: inherit;">
          <h2 style="font-size: 1.25rem; margin-bottom: 0.5em;">Whoa there, FlexiFan!</h2>
          <p style="margin-bottom: 2em;">You're trying to create a bundle with <b>${targetLimit} FlexiPals</b>, but <b>${currentCount} awesome pals</b> are partying in your bag. Ready to do a little bundle clean-up?</p>
          <button id="bundle-downgrade-blocked-close" style="background: #6CB4EE; color: #fff; border: none; border-radius: 4px; font-size: 1rem; padding: 10px 32px; cursor: pointer; font-weight: 600;">Okay!</button>
        </div>`;
      document.body.appendChild(popup);
      document.getElementById('bundle-downgrade-blocked-close').onclick = () => { popup.style.display = 'none'; };
    } else {
      popup.querySelector('p').innerHTML = `You're trying to create a bundle with <b>${targetLimit} FlexiPals</b>, but <b>${currentCount} awesome pals</b> are partying in your bag. Ready to do a little bundle clean-up?`;
      popup.style.display = 'flex';
    }
    popup.style.display = 'flex';
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', initBundle3);
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:unload', initBundle3);
      document.addEventListener('shopify:section:load', initBundle3);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('bundleToggleBtn');
    const section = document.getElementById('bundleSection');
    const svg = btn?.querySelector('svg');
    const fillRect = svg?.querySelector('#bagFillRect');
    const bagOutline = svg?.querySelector('#bagOutline');
    const chevron = svg?.querySelector('#toggleChevron');
    const mobileTarget = document.getElementById('sidebarProductsMobileTarget');
    if (!btn || !section || !svg || !fillRect || !bagOutline || !chevron) return;
    chevron.setAttribute('d', "M16 22 l4 4 4-4");
    function syncBagAndChevron() {
      if (section.classList.contains('bundle-expanded')) {
        fillRect.classList.add('hide-bag-visual');
        bagOutline.classList.add('hide-bag-visual');
        chevron.classList.add('show-chevron');
      } else {
        fillRect.classList.remove('hide-bag-visual');
        bagOutline.classList.remove('hide-bag-visual');
        chevron.classList.remove('show-chevron');
      }
    }
    syncBagAndChevron();
    btn.addEventListener('click', function () {
      section.classList.toggle('bundle-expanded');
      if (window.innerWidth < 1023) {
        mobileTarget.style.display = section.classList.contains('bundle-expanded') ? 'block' : 'none';
      }
      syncBagAndChevron();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth < 1023) {
        mobileTarget.style.display = section.classList.contains('bundle-expanded') ? 'block' : 'none';
      } else {
        mobileTarget.style.display = 'none';
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const bundleBagSection = document.querySelector('.bundle-bag-section');
    if (!bundleBagSection) return;
    function isButtonInBundleBagSection(event) {
      return event.target.closest && bundleBagSection.contains(event.target) && event.target.closest('button');
    }
    function conditionalPreventScroll(e) {
      if (isButtonInBundleBagSection(e)) e.preventDefault();
    }
    bundleBagSection.addEventListener('wheel', conditionalPreventScroll, { passive: false });
    bundleBagSection.addEventListener('touchmove', conditionalPreventScroll, { passive: false });
    bundleBagSection.addEventListener('keydown', function (e) {
      const active = document.activeElement;
      if (
        active &&
        bundleBagSection.contains(active) &&
        active.tagName === 'BUTTON' &&
        ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(e.key)
      ) {
        e.preventDefault();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateBagFill();
    window.addEventListener('resize', updateBagFill);
  });

})();